import type { FragmentType } from '@packages/gql/generated/shopping';
import { makeFragmentData } from '@packages/gql/generated/shopping';
import type {
  ColorTilesValuesFragmentFragmentDoc,
  DimensionFragmentFragment,
  SelectValuesFragmentFragmentDoc,
  TilesValuesFragmentFragmentDoc,
} from '@packages/gql/generated/shopping/graphql';
import { DimensionFragmentFragmentDoc } from '@packages/gql/generated/shopping/graphql';
import {
  getColorTilesDimensionFragmentedData,
  colorTilesDimensionDataMockManyColors,
  colorTilesDimensionDataMock,
} from './ColorTilesDimension/mockdata';
import { getTilesDimensionFragmentedData, tilesDimensionDataMock } from './TilesDimension/mockdata';
import {
  getSelectDimensionFragmentedData,
  selectDimensionDataMock,
} from './SelectDimension/mockdata';

export const variationSelectDataMockColorTiles: DimensionFragmentFragment = {
  type: 'TILES',
  axisType: 'COLOR',
  displayName: 'Color',
};

export const variationSelectDataMock: DimensionFragmentFragment = {
  type: 'TILES',
  axisType: 'COLOR',
  displayName: 'Color',
  ' $fragmentRefs': {
    ColorTilesValuesFragmentFragment: colorTilesDimensionDataMock,
    SelectValuesFragmentFragment: selectDimensionDataMock,
    TilesValuesFragmentFragment: tilesDimensionDataMock,
  },
};

export const variationSelectDataMockSizeTiles: DimensionFragmentFragment = {
  type: 'TILES',
  axisType: 'SIZE',
  displayName: 'Size',
};

export const variationSelectDataMockColorSelect: DimensionFragmentFragment = {
  type: 'SELECT',
  axisType: 'COLOR',
  displayName: 'Color',
};

export const variationSelectDataMockSizeSelect: DimensionFragmentFragment = {
  type: 'SELECT',
  axisType: 'SIZE',
  displayName: 'Size',
};

export function getVariationSelectFragmentedData(data: DimensionFragmentFragment) {
  return makeFragmentData(data, DimensionFragmentFragmentDoc);
}

export function getFragmentedDataWithFragmentData(
  data: DimensionFragmentFragment,
  dataType: 'ColorTiles' | 'Tiles' | 'Select',
) {
  let fragmentData: FragmentType<
    | typeof ColorTilesValuesFragmentFragmentDoc
    | typeof TilesValuesFragmentFragmentDoc
    | typeof SelectValuesFragmentFragmentDoc
  > = getColorTilesDimensionFragmentedData(colorTilesDimensionDataMockManyColors);
  if (dataType === 'Tiles') {
    fragmentData = getTilesDimensionFragmentedData(tilesDimensionDataMock);
  }
  if (dataType === 'Select') {
    fragmentData = getSelectDimensionFragmentedData(selectDimensionDataMock);
  }
  return makeFragmentData(
    { ...data, ...fragmentData[' $fragmentRefs'] },
    DimensionFragmentFragmentDoc,
  );
}
